import { CloseS12 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './Tag.css';

export interface ITagProps {
  onRemove(): void;
}

export const Tag: React.FC<ITagProps> = ({ children, onRemove }) => {
  return (
    <div className={styles['container']}>
      {children}
      <button className={styles['button']} onClick={onRemove}>
        <CloseS12 color="current_color" />
      </button>
    </div>
  );
};
